import React from 'react';

const FolderIcon: React.FC = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="icon">
    <title>breadcrumbs</title>
    <path
      d="M30.247 15.309l-2.6 10.923a1 1 0 0 1-.973.768H4.317a1 1 0 0 1-.966-1.26l2.952-10.923a1 1 0 0 1 .966-.74h22.005a1 1 0 0 1 .973 1.232z"
      fill="#00334d"
      fillRule="evenodd"
    />
    <path
      d="M3 6h5.965a1 1 0 0 1 .64.232l2.145 1.787h14.29a1 1 0 0 1 1 1v3.039H5.794a1 1 0 0 0-.965.739L2 23.267V7a1 1 0 0 1 1-1z"
      fill="#00334d"
      fillRule="evenodd"
    />
  </svg>
);

export { FolderIcon };
